import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import constructionSVG from "../../assets/construction.svg";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import FavoriteIcon from "@mui/icons-material/Favorite";

export function ComingSoon() {
  const { t } = useTranslation(["common"]);
  return (
    <Grid container marginTop={2}>
      <Grid item xs={1.5}></Grid>
      <Grid item xs={9} className="white fadein">
        <div className="coming-soon-container white">
          <h1>
            <DoDisturbOnIcon
              color="error"
              style={{
                width: "30px",
                height: "30px",
                marginLeft: "10px",
                marginRight: "10px",
                paddingTop: "2px"
              }}
            />
            {t("common:under_construction").toUpperCase()}
            <DoDisturbOnIcon
              color="error"
              style={{
                width: "30px",
                height: "30px",
                marginLeft: "10px",
                marginRight: "10px",
                paddingTop: "2px"
              }}
            />
          </h1>
          <h2>
            <FavoriteIcon
              color="warning"
              style={{
                width: "24px",
                height: "24px",
                marginLeft: "10px",
                marginRight: "10px",
                paddingTop: "2px"
              }}
            />
            {t("common:thanks_for_using")}
            <FavoriteIcon
              color="warning"
              style={{
                width: "24px",
                height: "24px",
                marginLeft: "10px",
                marginRight: "10px",
                paddingTop: "2px"
              }}
            />
          </h2>
        </div>
        <img src={constructionSVG} style={{ maxWidth: "50vh" }} />
      </Grid>
      <Grid item xs={1.5}></Grid>
    </Grid>
  );
}
